var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ion-input',{attrs:{"value":_vm.value,"readonly":_vm.readonly,"inputmode":"tel","debounce":"500","placeholder":"(212) 234-6789"},on:{"input":function($event){return _vm.update($event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }